import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import {
    globalStateFilterOnOff,
    IWebhook,
} from '@models';
import {
    GRID_SERVICE,
    ODataGridComponent,
    STATE_HANDLER,
    urlStateHandler,
} from '@pages/generics/grid';
import { WebhookService } from '@services/webhook.service';
import { IDropdownOption } from '@uipath/angular/components/ui-grid';

import { takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './webhooks.page.html',
    styleUrls: ['./webhooks.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{
        provide: GRID_SERVICE,
        useClass: WebhookService,
    },
    {
        provide: STATE_HANDLER,
        useValue: urlStateHandler,
    }],
    encapsulation: ViewEncapsulation.None,
})
export class WebhooksPageComponent extends ODataGridComponent<IWebhook, number> {

    public enabledValues: IDropdownOption[] = globalStateFilterOnOff();
    public isWebhooksEditGranted$ = this._appState.user.permissions.isGranted('Webhooks.Edit');

    public editItem(item: IWebhook) {
        this._router.navigate([`/webhooks/edit/${item.id}`]);
    }

    public handleEnabledToggle(
        entry: IWebhook,
        elem: MatSlideToggle,
    ) {
        if (entry.enabled) {
            elem.checked = true;

            this._modal.onConfirm(
                null,
                () => {
                    elem.checked = false;
                    this._setWebhookState(entry, false);
                },
                () => { },
                this._translate.instant('webhooks_grid_disable_confirmation', {
                    url: entry.url,
                }),
            );

        } else {
            elem.checked = true;
            this._setWebhookState(entry, true);
        }
    }

    private _setWebhookState(entry: IWebhook, active: boolean) {
        this.loading$.next(true);

        entry.enabled = active;

        (this._service as WebhookService)
            .toggleEnabled(entry)
            .pipe(
                takeUntil(this._destroyed$),
            ).subscribe(
                () => this._refresh$.next(),
                () => this._refresh$.next(),
            );
    }
}
